/**
 * Shared application constants
 */

import packageJson from '../../package.json';

// Application version - automatically pulled from package.json
export const APP_VERSION = `v${packageJson.version}`;
